import { TTreeViewModel } from '../../services/models/CourseViewModels';

export default function findPageById(pages: TTreeViewModel[], id: string): TTreeViewModel | null {
  function search(nodes: TTreeViewModel[]): TTreeViewModel | null {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }
      const found = search(node.children);
      if (found) {
        return found;
      }
    }
    return null;
  }

  return search(pages);
}
